import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Modal, Paper, IconButton, Typography, Stack, Button } from '@mui/material';
import { MdClose } from 'react-icons/md';
import { useBookMyOpAuth } from '../contexts/BookMyOpAuthContext';
import Navbar from './Home/Navbar';
import NotificationBell from '../components/NotificationBell';
import MobileBottomNav from '../components/MobileBottomNav';

const MainLayout = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { isAuthenticated } = useBookMyOpAuth();

  const handleSignUpClick = () => {
    setShowAuthModal(true);
  };

  const handleModalClose = () => {
    setShowAuthModal(false);
  };

  const handleLoginClick = () => {
    setShowAuthModal(false);
    navigate('/login');
  };

  return (
    <>
      <Navbar onAuthClick={handleSignUpClick} notificationBell={<NotificationBell />} />
      <Outlet />
      <MobileBottomNav onAuthClick={handleSignUpClick} />

      <Modal
        open={showAuthModal && !isAuthenticated}
        onClose={handleModalClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Paper sx={{ 
          position: 'relative',
          width: '90%',
          maxWidth: 400,
          p: 4,
          borderRadius: 2
        }}>
          <IconButton
            onClick={handleModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <MdClose />
          </IconButton>
          <Typography variant="h5" textAlign="center" mb={3}>
            Welcome to BookMyOP
          </Typography>
          <Stack spacing={2}>
            <Button variant="contained" fullWidth onClick={handleLoginClick}>
              Login
            </Button>
          </Stack>
        </Paper>
      </Modal>
    </>
  );
};

export default MainLayout; 